export const REPORT_ID = "slide-34";
export const SLIDE_NUMBER = 34;
export const MIN_DATE = 120000101;
export const BUSINESS_UNIT = 1;
export const colors = ["#E38114", "#8F8F8F", "#000000", "#d9d9d9", "#f7f7f7"];
export const RICE = 1001